import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { Tooltip } from '@/components/atoms/Tooltip/Tooltip';
import toolTipIconSrc from '~/icons/tooltip_icon.svg';
import { SvgIcon } from '@/components/SvgIcon';

export interface ProductFeaturesProps {
  productFeature?: RichTextFieldStrapiProps;
  featureImage?: ImageStrapiProps;
  tooltipText?: RichTextFieldStrapiProps;
}

export function ProductFeatures({
  productFeature,
  featureImage,
  tooltipText,
}: ProductFeaturesProps) {
  return (
    <div className='flex gap-2'>
      {featureImage ? (
        <ImageStrapi
          block={featureImage}
          inner={{ classNames: { image: 'w-6 h-6' } }}
        />
      ) : (
        <div className='text-body-m text-base-black text-wrap'>
          <RichTextFieldStrapi
            block={{
              ...productFeature,
            }}
          />
        </div>
      )}
      {!!tooltipText && (
        <Tooltip
          flowDirection='bottom-center'
          text={
            <RichTextFieldStrapi
              block={{
                ...tooltipText,
              }}
            />
          }
          classNames={{ text: 'max-w-[200px]' }}
        >
          <SvgIcon src={toolTipIconSrc} className='group-hover:text-brand-900 h-5 w-5 text-gray-400' />
        </Tooltip>
      )}
    </div>
  );
}
